<template>
  <!-- 带导航的插槽 -->
  <el-main>
    <breadcrumb :afterItem="breadcrumbList"  :beforeItem="{ name:  $t('breadcrumbBefore[1]'), to: '/jiyun' }" v-if="breadcrumb" />
    <slot />
  </el-main>
</template> 
<script>
import breadcrumb from "@/components/layout/Breadcrumb";

export default {
  
  props: {
    breadcrumb: {
      type: Boolean,
      default: true
    },
    breadcrumbList: {
      type: [Array, String],
      default: ""
    }
  },
  components: {
    breadcrumb
  }
};
</script>
<style scoped>
</style>